"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayMetadata = exports.LocationData = void 0;
const swagger_1 = require("@nestjs/swagger");
const display_1 = require("../dto/display");
/**
 * Geographic location data with coordinates
 */
class LocationData {
    type;
    coordinates;
}
exports.LocationData = LocationData;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: 'Type of geographic data (usually "Point" for GeoJSON)',
        example: 'Point',
    }),
    __metadata("design:type", String)
], LocationData.prototype, "type", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: 'Geographic coordinates as [longitude, latitude]',
        type: [Number],
        example: [-74.006, 40.7128],
        minItems: 2,
        maxItems: 2,
    }),
    __metadata("design:type", Array)
], LocationData.prototype, "coordinates", void 0);
/**
 * Display metadata containing hardware, location, and network information
 * Comprehensive data about a display device and its environment
 */
class DisplayMetadata {
    playerType;
    macAddress;
    playerVersion;
    outputState;
    playerUpdate;
    playerUpdateStatus;
    ladorian;
    platformProviderAudit;
    creativePreview;
    location;
    address;
    location_history;
    browserData;
    city;
    continentCode;
    country;
    countryName;
    currentIp;
    displayLanguage;
    displayNits;
    displayPrice;
    ip;
    isLandscape;
    isp;
    ispName;
    lastIp;
    latitude;
    longitude;
    manufacturer;
    memoryData;
    model;
    region;
    resolution;
    screenData;
    timezone;
    totalPlayingHours;
    windowData;
}
exports.DisplayMetadata = DisplayMetadata;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Player implementation last reported by the display',
        enum: ['player-web', 'player-native'],
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "playerType", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Primary hardware MAC reported by the display, when available',
        example: '00:EF:02:00:37:49',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "macAddress", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'APK version currently running on a native player',
        example: {
            packageName: 'com.admefy.admefy_player',
            versionName: '2.3.4',
            versionCode: 36,
        },
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "playerVersion", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Latest output/power state reported by the player. Optional and best-effort.',
    }),
    __metadata("design:type", display_1.DisplayOutputStateMetadataDto)
], DisplayMetadata.prototype, "outputState", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'APK update assigned to this display. The object key is never exposed directly.',
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "playerUpdate", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Latest installation state reported for the assigned APK release.',
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "playerUpdateStatus", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: 'Ladorian inventory identity and state' }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "ladorian", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Bounded audit history of administrator changes to the platform provider',
    }),
    __metadata("design:type", Array)
], DisplayMetadata.prototype, "platformProviderAudit", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Placeholder image and normalized area used to preview creatives in context',
        example: {
            imageUrl: 'https://cdn.admefy.com/display-previews/display-1-123.webp',
            imageName: 'gym-preview.webp',
            imageMimeType: 'image/webp',
            imageWidth: 1792,
            imageHeight: 1344,
            updatedAt: '2026-06-29T10:23:57.000Z',
            area: {
                points: [
                    { x: 0.322, y: 0.331 },
                    { x: 0.601, y: 0.326 },
                    { x: 0.603, y: 0.531 },
                    { x: 0.315, y: 0.522 },
                ],
            },
        },
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "creativePreview", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Current geographic location of the display',
        type: LocationData,
        example: {
            type: 'Point',
            coordinates: [-74.006, 40.7128],
        },
    }),
    __metadata("design:type", LocationData)
], DisplayMetadata.prototype, "location", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Human-readable address resolved from the display location',
        example: 'Carrer de la Ciutat, 07800 Ibiza, Illes Balears, Spain',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "address", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'History of geographic locations where the display has been',
        type: [LocationData],
        example: [
            { type: 'Point', coordinates: [-74.006, 40.7128] },
            { type: 'Point', coordinates: [-73.935, 40.73] },
        ],
    }),
    __metadata("design:type", Array)
], DisplayMetadata.prototype, "location_history", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Browser and user agent information',
        example: {
            userAgent: 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36',
            language: 'en-US',
            platform: 'Linux x86_64',
        },
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "browserData", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'City name where the display is located',
        example: 'New York',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "city", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Continent code (two-letter code)',
        example: 'NA',
        maxLength: 2,
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "continentCode", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Country code (two-letter ISO code)',
        example: 'US',
        maxLength: 2,
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "country", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Full country name',
        example: 'United States',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "countryName", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Current IP address of the display',
        example: '192.168.1.100',
        format: 'ipv4',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "currentIp", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Display language/locale setting',
        example: 'en-US',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "displayLanguage", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Display brightness in nits',
        example: 300,
        minimum: 0,
        maximum: 10000,
    }),
    __metadata("design:type", Number)
], DisplayMetadata.prototype, "displayNits", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Display price in the local currency',
        example: 1200.5,
        minimum: 0,
    }),
    __metadata("design:type", Number)
], DisplayMetadata.prototype, "displayPrice", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'IP address of the display',
        example: '192.168.1.100',
        format: 'ipv4',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "ip", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Whether the display is in landscape orientation',
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayMetadata.prototype, "isLandscape", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Internet Service Provider code',
        example: 'COMCAST-7922',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "isp", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Internet Service Provider name',
        example: 'Comcast Cable Communications',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "ispName", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Last known IP address of the display',
        example: '192.168.1.99',
        format: 'ipv4',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "lastIp", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Latitude coordinate (string format)',
        example: '40.7128',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "latitude", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Longitude coordinate (string format)',
        example: '-74.0060',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "longitude", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Display manufacturer name',
        example: 'Samsung',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "manufacturer", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Memory usage and capacity information',
        example: {
            total: 8589934592,
            used: 4294967296,
            available: 4294967296,
        },
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "memoryData", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Display model name',
        example: 'QM55H-B',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "model", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Geographic region or state',
        example: 'New York',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "region", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Display resolution in width x height format',
        example: '1920x1080',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "resolution", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Screen hardware and configuration data',
        example: {
            width: 1920,
            height: 1080,
            colorDepth: 24,
            pixelDepth: 24,
        },
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "screenData", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Timezone identifier (IANA timezone)',
        example: 'America/New_York',
    }),
    __metadata("design:type", String)
], DisplayMetadata.prototype, "timezone", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Total hours the display has been playing content',
        example: 1440.5,
        minimum: 0,
    }),
    __metadata("design:type", Number)
], DisplayMetadata.prototype, "totalPlayingHours", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: 'Window and viewport information',
        example: {
            innerWidth: 1920,
            innerHeight: 1080,
            outerWidth: 1920,
            outerHeight: 1080,
        },
    }),
    __metadata("design:type", Object)
], DisplayMetadata.prototype, "windowData", void 0);
